export default __webpack_public_path__ + "static/media/0.d3898b33.svg";